module.exports = {
          srcSet: __webpack_public_path__ + "4986729a74f37d90dc1ef01ce99e3ce1-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "4986729a74f37d90dc1ef01ce99e3ce1-1920.png",width: 1920,height: 865}],
          src: __webpack_public_path__ + "4986729a74f37d90dc1ef01ce99e3ce1-1920.png",
          toString:function(){return __webpack_public_path__ + "4986729a74f37d90dc1ef01ce99e3ce1-1920.png"},
          
          width: 1920,
          height: 865
        }